import Layout from "./../../Components/Navbar";
import React, { useEffect } from "react";
import FAQSupportComponent from "../AccountOverview/FaqComponent";
import QuickActions from "../AccountOverview/QuickAction";
import { AccountUnderReview } from "./../../Public/assets";
import { Button } from "./../../Components/ui/button";
import { getSession } from "./../../axios.config";
import { useOverview, useSettings } from "./../../hooks";
import { useNavigate } from "react-router-dom";
import BackToUnified from "./../../Components/sideBar/backToUnified.js";
// import BorderlessMoneyBanner from "../../Components/BorderlessMoneyBanner";

function AccountVerification() {
  // const { useAccountData } = useSettings();

  const { useGlobalAccount } = useOverview();

  const userList = JSON.parse(getSession("userId"));

  // const { data: AccountData } = useAccountData(
  //   userList?.userId || userList?.userData?.userId
  // );
  const navigate = useNavigate();

  const { data: globalData } = useGlobalAccount();

  useEffect(() => {
    if (
      globalData?.data?.status === "APPROVED" &&
      globalData?.data?.user?.status === "APPROVED"
    ) {
      navigate("/home");
    }
  }, [globalData]);

  return (
    <>
      <Layout notVerified={globalData?.data?.user?.status === "PENDING"}>
        {/* h-[calc(100dvh-146px)] */}
        {/* <BorderlessMoneyBanner /> */}
        <div className={`overflow-scroll  lg:pt-10 `}>
          <div className=" mt-[64px] md:mt-[100px] h-[336px]  px-[64px]  py-[48px] lg:rounded-xl  lg:!mx-40 bg-Kyc-pending-gradient   mb-[63px]">
            <div className="flex overflow-visible bg-no-repeat md:bg-white-shadow ">
              <div className={`md:w-[60%]`}>
                <h2 className="text-[16px] leading-[24px] font-geomanistBold text-greyish mb-4">
                  {/* Hi {user?.[0]}, */}
                  Hi{" "}
                  {globalData?.data?.user?.name?.split(" ")?.[0]
                    ? globalData?.data?.user?.name?.split(" ")?.[0]
                    : userList?.firstName}
                  ,
                </h2>

                <h2 className="font-geomanistMedium  text-[26px] md:text-[36px]   leading-[28px] md:leading-[44px] mb-4 text-blackShade">
                  Your Borderless Multi-currency{" "}
                  <br className="hidden xl:block" /> Account is under review.
                </h2>
                <p className="mb-6 text-[10px] md:text-[14px] leading-[16px] md:leading-[20px] text-greyish">
                  It generally takes 48 hours for the account to get activated.
                </p>
                <Button
                  varient="outline"
                  className="w-[111px] bg-transparent !text-blueish border border-blueish hover:bg-transparent/5"
                  onClick={() => {
                    window.open(
                      "https://borderlesssofttechprivatelimited.zohodesk.in/portal/en/kb/borderless-multicurrency-account",
                      "_blank",
                    );
                  }}
                >
                  Learn more{" "}
                </Button>
              </div>
              <div className="hidden md:w-[40%] md:flex justify-center items-center">
                <img src={AccountUnderReview} alt="" />
              </div>
            </div>
          </div>

          <div className=" border-t-2  lg:!mx-40 mb-[24px] lg:mb-[33px] lg:border-t-0">
            <QuickActions arrow={false} />
          </div>
          <FAQSupportComponent />
        </div>
      </Layout>
      <BackToUnified />
    </>
  );
}

export default AccountVerification;
